export default function ActivitatiExtracurriculare() {

  const files = [
    "Raport activitate Scoala altfel.PDF",
    "Raport_Saptamana_Verde_2026.pdf",
    "Acord de partaenaria_CJRAE_Pas cu pas spre liceu.PDF",
    "Acord de parteneriat_activitate sportiva.PDF",
    "Acord de parteneriat_Asociatia Ars Vivat.PDF",
    "Acord de parteneriat_Asociatia parintilor.PDF",
    "Acord de parteneriat_Biblioteca Oras Ulmeni.PDF",
    "Acord de parteneriat_Cabinet medical.PDF",
    "Acord de parteneriat_Caregivers .PDF",
    "Acord de parteneriat_CJRAE_Absenteism de la cauza la efect.PDF",
    "Acord de parteneriat_CJRAE_Atitudinea conteaza.PDF",
    "Acord de parteneriat_CJRAE_Bullying_cyberbullying.PDF",
    "Acord de parteneriat_CJRAE_Curcubeul prieteniei.PDF",
    "Acord de parteneriat_CJRAE_Fii cool prin bunatate.PDF",
    "Acord de parteneriat_CJRAE_Pas cu pas spre scoala.PDF",
    "Acord de parteneriat_CJRAE_prevenirea anxietatii si a temerilor legate de scoala.PDF",
    "Acord de parteneriat_Politia Oras Ulmeni.PDF",
    "Acord de parteneriat_Primaria Oras Ulmeni.PDF",
    "Acord de parteneriat_Sala de sport Oras Ulmeni.PDF",
    "Acord parteneriat_CJRAE_Saptamana meseriilor.PDF",
    "Colaborare_slimm_prim ajutor.PDF",
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">

        <h2 className="text-xl font-bold mb-4">
          Activități extracurriculare
        </h2>

        <div className="space-y-2">
          {files.map((file) => (
            <p key={file}>
              <a
                href={`/programe/activitatiExtracurriculare/${file}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
             {file}
              </a>
            </p>
          ))}
        </div>

      </main>
    </div>
  );
}